import * as actions from "./actions";
import _ from "underscore";
import update from "immutability-helper";

import moment from "moment";

let initialState = {
  bonus: {
    sending: false,
    sent: false,
    fetching: false,
    fetched: false,
    confirming: false,
    confirmed: false,
    data: [],
    error: null,
  },
  deposit: {
    fetching: false,
    fetched: false,
    fetchError: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },
  withdraw: {
    fetching: false,
    fetched: false,
    fetchError: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },
  sendBacks: {
    fetching: false,
    fetched: false,
    fetchError: null,
    data: [],
  },
  approve: {
    error: null,
    response: null,
    dataSent: null,
  },
  reject: {
    error: null,
    response: null,
    dataSent: null,
  },
  placeWithdrawal: {
    error: null,
    sending: false,
    sent: false,
  },
  placeForceWithdrawal: {
    error: null,
    sending: false,
    sent: false,
  },
  placeMegaForceWithdrawal: {
    error: null,
    sending: false,
    sent: false,
  },
};

const orders = (state = initialState, action) => {
  switch (action.type) {
    // GET ORDERS
    case actions.DEPOSIT_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });
    case actions.DEPOSIT_LIST_GET_SUCCESS:
      var data = action.response;
      var datenow = moment().subtract(30, "days");
      var allData = data;

      data = _.filter(data, (value) => {
        return datenow < moment(value.OrderDate);
      });

      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          fetching: false,
          fetched: true,
          data,
          swapData: allData,
        }),
      });
    case actions.SWAP_DEPOSIT_DATA:
      var dataInternal = state.deposit.data;
      var swapData = state.deposit.swapData;

      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          data: swapData,
          swapData: dataInternal,
        }),
      });

    case actions.DEPOSIT_LIST_GET_ERROR:
      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          fetching: false,
          fetchError: action.error,
        }),
      });
    case actions.WITHDRAW_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });
    case actions.WITHDRAW_LIST_GET_SUCCESS:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.WITHDRAW_LIST_GET_ERROR:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          fetching: false,
          fetchError: action.error,
        }),
      });

    case actions.SEND_BACK_LIST_GET_REQUEST:
      return update(state, {
        sendBacks: {
          data: { $set: [] },
          fetching: { $set: true },
          fetchError: { $set: null },
        },
      });

    case actions.SEND_BACK_LIST_GET_SUCCESS:
      return update(state, {
        sendBacks: {
          data: { $set: action.response },
          fetching: { $set: false },
          fetched: { $set: true },
        },
      });

    case actions.SEND_BACK_LIST_GET_ERROR:
      return update(state, {
        sendBacks: {
          data: { $set: action.response },
          fetching: { $set: false },
          fetchError: { $set: action.error },
        },
      });

    // APPROVE REJECT ORDER
    case actions.APPROVE_DEPOSIT_ORDER_REQUEST:
      return Object.assign({}, state, {
        approve: Object.assign({}, state.approve, {
          dataSent: action.dataSent,
        }),
      });
    case actions.APPROVE_DEPOSIT_ORDER_SUCCESS:
      //After approval the deposit is then removed from the list
      var orderToRemoveIndex = _.findIndex(state.deposit.data, (order) => {
        return order.Id == action.dataSent.OrderId;
      });

      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          data: [
            ...state.deposit.data.slice(0, orderToRemoveIndex),
            ...state.deposit.data.slice(orderToRemoveIndex + 1),
          ],
        }),
        approve: Object.assign({}, state.approve, {
          response: action.response,
          dataSent: action.dataSent,
        }),
      });
    case actions.APPROVE_DEPOSIT_ORDER_ERROR:
      return Object.assign({}, state, {
        approve: Object.assign({}, state.approve, {
          error: action.error,
          response: null,
          dataSent: action.dataSent,
        }),
      });
    case actions.REJECT_ORDER_REQUEST:
      return Object.assign({}, state, {
        reject: Object.assign({}, state.reject, {
          dataSent: action.dataSent,
        }),
      });
    case actions.REJECT_ORDER_SUCCESS:
      return Object.assign({}, state, {
        reject: Object.assign({}, state.reject, {
          response: action.response,
          dataSent: action.dataSent,
        }),
      });
    case actions.REJECT_ORDER_ERROR:
      return Object.assign({}, state, {
        reject: Object.assign({}, state.reject, {
          error: action.error,
          response: null,
          dataSent: action.dataSent,
        }),
      });
    // Approve and cancel withdrawals
    case actions.APPROVE_WITHDRAWAL_ORDER_SUCCESS:
    case actions.CANCEL_WITHDRAWAL_ORDER_SUCCESS:
      //After approval the deposit is then removed from the list
      var orderToRemoveIndexInternal = _.findIndex(
        state.withdraw.data,
        (order) => {
          return order.Id === action.dataSent.OrderId;
        },
      );

      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          data: [
            ...state.withdraw.data.slice(0, orderToRemoveIndexInternal),
            ...state.withdraw.data.slice(orderToRemoveIndexInternal + 1),
          ],
        }),
      });
    // List paging and filtering
    case actions.DEPOSITS_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          table: Object.assign({}, state.deposit.table, {
            pagination: Object.assign({}, state.deposit.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });
    case actions.DEPOSITS_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        deposit: Object.assign({}, state.deposit, {
          table: Object.assign({}, state.deposit.table, {
            currentFilter: Object.assign(
              {},
              state.deposit.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    case actions.WITHDRAWAL_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          table: Object.assign({}, state.withdraw.table, {
            pagination: Object.assign({}, state.withdraw.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });
    case actions.WITHDRAWAL_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        withdraw: Object.assign({}, state.withdraw, {
          table: Object.assign({}, state.withdraw.table, {
            currentFilter: Object.assign(
              {},
              state.withdraw.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    case actions.PLACE_WITHDRAWAL_ORDER_REQUEST:
      return Object.assign({}, state, {
        placeWithdrawal: Object.assign({}, state.placeWithdrawal, {
          error: null,
          sending: true,
        }),
      });
    case actions.PLACE_WITHDRAWAL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        placeWithdrawal: Object.assign({}, state.placeWithdrawal, {
          error: null,
          sending: false,
          sent: true,
        }),
      });
    case actions.PLACE_WITHDRAWAL_ORDER_ERROR:
      return Object.assign({}, state, {
        placeWithdrawal: Object.assign({}, state.placeWithdrawal, {
          error: action.error,
          sending: false,
        }),
      });
    case actions.PLACE_FORCE_WITHDRAWAL_ORDER_REQUEST:
      return Object.assign({}, state, {
        placeForceWithdrawal: Object.assign({}, state.placeForceWithdrawal, {
          error: null,
          sending: true,
        }),
      });
    case actions.PLACE_FORCE_WITHDRAWAL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        placeForceWithdrawal: Object.assign({}, state.placeForceWithdrawal, {
          error: null,
          sending: false,
          sent: true,
        }),
      });
    case actions.PLACE_FORCE_WITHDRAWAL_ORDER_ERROR:
      return Object.assign({}, state, {
        placeForceWithdrawal: Object.assign({}, state.placeForceWithdrawal, {
          error: action.error,
          sending: false,
        }),
      });
    case actions.PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_REQUEST:
      return Object.assign({}, state, {
        placeMegaForceWithdrawal: Object.assign(
          {},
          state.placeForceWithdrawal,
          {
            error: null,
            sending: true,
          },
        ),
      });
    case actions.PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_SUCCESS:
      return Object.assign({}, state, {
        placeMegaForceWithdrawal: Object.assign(
          {},
          state.placeForceWithdrawal,
          {
            error: null,
            sending: false,
            sent: true,
          },
        ),
      });
    case actions.PLACE_MEGA_FORCE_WITHDRAWAL_ORDER_ERROR:
      return Object.assign({}, state, {
        placeMegaForceWithdrawal: Object.assign(
          {},
          state.placeForceWithdrawal,
          {
            error: action.error,
            sending: false,
          },
        ),
      });
    // Bonus registration
    case actions.REGISTER_BONUS_REQUEST:
      return Object.assign({}, state, {
        bonus: Object.assign({}, state.bonus, {
          error: null,
          sending: true,
          sent: false,
        }),
      });
    case actions.REGISTER_BONUS_SUCCESS:
      return Object.assign({}, state, {
        bonus: Object.assign({}, state.bonus, {
          error: null,
          sending: false,
          sent: true,
        }),
      });
    case actions.REGISTER_BONUS_ERROR:
      return Object.assign({}, state, {
        bonus: Object.assign({}, state.bonus, {
          error: action.error,
          sending: false,
        }),
      });
    case actions.FETCH_CREATED_BONUS_REQUEST:
      return Object.assign({}, state, {
        bonus: Object.assign({}, state.bonus, {
          fetching: true,
        }),
      });
    case actions.FETCH_CREATED_BONUS_SUCCESS:
      return Object.assign({}, state, {
        bonus: Object.assign({}, state.bonus, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    case actions.CONFIRM_BONUS_SUCCESS:
    case actions.CANCEL_BONUS_SUCCESS: {
      let toBeRemovedOrderId = action.dataSent.OrderId;
      let filteredOrders = _.filter(state.bonus.data, (item) => {
        return item.Id !== toBeRemovedOrderId;
      });

      return Object.assign({}, state, {
        bonus: Object.assign({}, state.bonus, {
          data: [...filteredOrders],
        }),
      });
    }
    default:
      return state;
  }
};

export default orders;
